import { render, staticRenderFns } from "./ExplorePersonas.vue?vue&type=template&id=3b3bb40e&scoped=true&"
import script from "./ExplorePersonas.vue?vue&type=script&lang=js&"
export * from "./ExplorePersonas.vue?vue&type=script&lang=js&"
import style0 from "./ExplorePersonas.vue?vue&type=style&index=0&id=3b3bb40e&lang=scss&scoped=true&"
import style1 from "./ExplorePersonas.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bb40e",
  null
  
)

export default component.exports